import React from 'react';

import { ListItemIcon } from '@mui/material';

import type { DeclarativeMenuItemProps } from './DeclarativeMenuItem';

export function DeclarativeMenuItemIcon(props: Pick<DeclarativeMenuItemProps, 'icon'>) {
  const { icon } = props;
  if (icon === 'none') return null;
  return (
    <ListItemIcon sx={{ color: 'inherit', minWidth: 24, position: 'relative' }}>
      {icon === 'gap' ? null : icon}
    </ListItemIcon>
  );
}
